<template>
  <div class="dashboard-hdg-aside-menu">
    <div class="view" @click="group1.changeVisible" role="button">
      <template v-if="!group1.isVisible">
        <span class="tip">非表示</span>
        <FontawesomeIcon class="icn" :icon="['far','eye-slash']" />
      </template>
      <template v-else>
        <span class="tip">表示</span>
        <FontawesomeIcon class="icn" :icon="['far','eye']" />
      </template>
    </div>
    <div class="position"
      @click="group1.openWidgetChangePositionWindow"
      >
      <ButtonChangePosition />
    </div>
    <div class="number">
      <div class="formparts select"
        @mouseenter="group1.isVisibleCountList = true"
        @mouseleave="group1.isVisibleCountList = false"
        :class="{'is-visible-list': group1.isVisibleCountList}"
      >
        <div class="select-label ta-center" role="select">{{ group1.count }}<FontawesomeIcon :icon="group1.isVisibleCountList ? 'angle-up' : 'angle-down'" class="icn" /></div>
        <div class="select-option">
          <ul class="select-option-list ta-center">
            <li class="ta-center" role="option" v-for="n of 30" :key="n">
              <label><input type="radio" @click="group1.isVisibleCountList = false; group1.changeCount(n)" :value="n">{{ n }}</label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'

import * as logicDashboardWidgetCustomizeParts from '@/logic/dashboard/DashboardWidgetCustomizeParts'

export default defineComponent({
  props: {
    widgetType: {
      type: String,
      required: true
    },
    parentGroup1: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicDashboardWidgetCustomizeParts.getGroup(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>

</style>
